module.exports = __webpack_public_path__ + "ms.cbd3f274.svg";